import React, { useEffect, useRef, useState } from "react";

import {
  View,
  Modal as RNModal,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
} from "react-native";
import {
  Img,
  Text,
  Icon,
  Modal,
  Header,
  Button,
  LoadingBox,
  AddButtonFloat,
} from "components";

import * as ImagePicker from "expo-image-picker";
// import { ImageEditor as CropView } from "expo-crop-image";
import CropView from "./WebImageCropper";
import Resizer from "react-image-file-resizer";

import { sizes, colors, strings } from "assets/constants";
import { useFlag } from "hooks";
import css from "styles";

import { useAddProductPic, useDeleteProductPic } from "clients/apis";
import { sn, dataUrlToFile } from "utils";
import tinycolor from "tinycolor2";

export default function Pictures(props: ProductPicturesT) {
  const { visible, hide, productId, images } = props;

  const [pics, setPics] = useState<Array<ImageUploaderT>>([]);

  useEffect(() => {
    if (images && images?.length > 0) {
      setPics(images?.map((img) => ({ id: img.id, uri: img.url })));
    } else {
      setPics([]);
    }
  }, [images]);

  const imageCropper = useRef<any>();
  const [originalPic, setOriginalPic] = useState<ImageUploaderT>();

  const [selectedPic, setSelectedPic] = useState<ImageUploaderT>();

  const addProductPicMut = useAddProductPic();
  const deleteProductPicMut = useDeleteProductPic();

  const { flg: menu, on: showMenu, off: hideMenu } = useFlag();
  const { flg: cropper, on: showCropper, off: hideCropper } = useFlag();

  const _onAddProductPic = (
    uri: string,
    size: { width: number; height: number }
  ) => {
    hideCropper();

    Resizer.imageFileResizer(
      dataUrlToFile(uri, "test.png"),
      size.width,
      size.height,
      "JPEG",
      80,
      0,
      (resizedImage) => {
        const imageFile =
          resizedImage &&
          dataUrlToFile(resizedImage as any, `carpet${Date.now()}`);

        const data = new FormData();
        data.append("image", imageFile, imageFile.name);
        productId &&
          addProductPicMut.mutate(
            { productId, data },
            {
              onSuccess: (response) => {
                const id = response.data.id;
                setPics((prev) => [
                  ...prev,
                  { id, uri: resizedImage as string },
                ]);
              },
            }
          );
      },
      "base64"
    );

    // const imageFile = uri && dataUrlToFile(uri, `carpet${Date.now()}`);

    // const data = new FormData();
    // data.append("image", imageFile, imageFile.name);
    // productId &&
    //   addProductPicMut.mutate(
    //     { productId, data },
    //     {
    //       onSuccess: (response) => {
    //         const id = response.data.id;
    //         setPics((prev) => [...prev, { id, uri }]);
    //       },
    //     }
    //   );
  };

  const options: ImagePicker.ImagePickerOptions = {
    mediaTypes: ImagePicker.MediaTypeOptions.Images,
    quality: 0.2,
  };
  const _imagePickerCallback = (res: ImagePicker.ImagePickerResult) => {
    if (res?.canceled) {
      return;
    }

    const results = res?.assets;
    results &&
      setOriginalPic({
        uri: results?.[0]?.uri,
        type: results?.[0]?.type,
        name: results?.[0]?.fileName,
        width: results?.[0]?.width,
        height: results?.[0]?.height,
      });
    showCropper();
  };

  const _pickFromCamera = () => {
    hideMenu();
    ImagePicker.launchCameraAsync(options).then(_imagePickerCallback);
  };

  const _pickFromGallery = () => {
    hideMenu();
    ImagePicker.launchImageLibraryAsync(options).then(_imagePickerCallback);
  };

  const _onDeletePic = (picId: number) => {
    productId &&
      deleteProductPicMut.mutate(
        { picId, productId },
        {
          onSuccess: () => {
            const newPics = pics.filter((p) => p.id !== picId);
            setPics(newPics);
          },
        }
      );
  };

  return (
    <RNModal visible={visible} animationType="slide" onRequestClose={hide}>
      <Header
        title="بارگذاری تصاویر محصول"
        renderLeft={() => (
          <Button
            onPress={hide}
            circle={50}
            bgColor={colors.transparent}
            icon={{ name: "check", size: 29, color: colors.theme }}
          />
        )}
      />
      <ScrollView contentContainerStyle={css.growContainer}>
        {pics.length === 0 && (
          <View style={css.centralElContainer}>
            <Icon name="image" size={50} color={colors.iconColor} />
            <Text style={{ marginTop: 20 }}>
              تصویری برای این محصول بارگذاری نشده است
            </Text>
            <Text>برای بارگذاری تصویر جدید بر روی دکمه + کلیک کنید</Text>
          </View>
        )}
        <View
          style={{
            ...css.wrap,
            ...css.rRowCenterAlign,
          }}
        >
          {pics?.map((pic: ImageUploaderT, key: number) => {
            return (
              <View key={String(key)} style={styles.imageContainer}>
                <View style={styles.image}>
                  <Img
                    style={styles.image}
                    source={{ uri: pic.uri }}
                    resizeMode="contain"
                  />
                  <View
                    style={{
                      bottom: 0,
                      height: 40,
                      padding: 1,
                      ...css.absolute,
                      ...css.fitWidth,
                      ...css.selfCenter,
                      ...css.rRowCenterAlign,
                      backgroundColor: colors.white + "cc",
                    }}
                  >
                    <Button
                      onPress={() => setSelectedPic(pic)}
                      bgColor={colors.transparent}
                      height={40}
                      width={"49%"}
                      icon={{ name: "eye", color: colors.info, size: 22 }}
                    />
                    <View
                      style={{
                        width: 2,
                        ...css.fitHeight,
                        backgroundColor: colors.black + "18",
                      }}
                    />
                    <Button
                      onPress={() => pic.id && _onDeletePic(pic.id)}
                      bgColor={colors.transparent}
                      height={40}
                      width={"49%"}
                      icon={{
                        name: "trash-2",
                        color: colors.danger,
                        size: 20,
                      }}
                    />
                  </View>
                </View>
              </View>
            );
          })}
        </View>
      </ScrollView>

      <AddButtonFloat onPress={showMenu} />

      <Modal hideCloseBtn hideToast visible={menu} close={hideMenu}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-around",
            paddingVertical: 30,
          }}
        >
          <TouchableOpacity
            style={{
              ...styles.pickButton,
              backgroundColor: tinycolor(colors.info).lighten(60).toString(),
            }}
            activeOpacity={sizes.tapOpacity}
            onPress={_pickFromCamera}
          >
            <Icon size={30} name="camera" color={colors.info} />
            <Text
              style={{
                marginTop: sn(
                  sizes.space / 2,
                  sizes.space / 2,
                  sizes.space,
                  sizes.space
                ),
              }}
              weight="bold"
              size={sn("lg", "lg", "xl", "xl")}
            >
              {strings.camera}
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={{
              ...styles.pickButton,
              backgroundColor: tinycolor(colors.success).lighten(53).toString(),
            }}
            activeOpacity={sizes.tapOpacity}
            onPress={_pickFromGallery}
          >
            <Icon size={30} name="image" color={colors.success} />
            <Text
              style={{
                marginTop: sn(
                  sizes.space / 2,
                  sizes.space / 2,
                  sizes.space,
                  sizes.space
                ),
              }}
              weight="bold"
              size={sn("lg", "lg", "xl", "xl")}
            >
              {strings.gallery}
            </Text>
          </TouchableOpacity>
        </View>
      </Modal>

      {originalPic?.uri && CropView !== null && (
        <CropView
          isVisible={cropper}
          image={originalPic}
          close={hideCropper}
          onCrop={_onAddProductPic}
        />
        // <CropView
        //   isVisible={cropper}
        //   fixedAspectRatio={3 / 4}
        //   imageUri={originalPic?.uri}
        //   onEditingCancel={hideCropper}
        //   onEditingComplete={_onAddProductPic}
        // />
      )}

      <RNModal
        visible={selectedPic !== undefined}
        onRequestClose={() => setSelectedPic(undefined)}
      >
        <View
          style={{ ...css.centralElContainer, backgroundColor: colors.black }}
        >
          <Button
            onPress={() => setSelectedPic(undefined)}
            absolute
            top={10}
            left={10}
            circle={45}
            style={{ zIndex: 1000 }}
            bgColor={colors.transparent}
            icon={{ name: "x", size: 24, color: colors.white }}
          />
          <Img
            source={{ uri: selectedPic?.uri }}
            resizeMode="contain"
            style={{ ...css.container, ...css.fitWidth }}
          />
        </View>
      </RNModal>

      {(addProductPicMut?.isLoading || deleteProductPicMut?.isLoading) && (
        <LoadingBox />
      )}
    </RNModal>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.screensBg,
    flexGrow: 1,
    flexDirection: "row-reverse",
    flexWrap: "wrap",
    alignItems: "center",
  },

  imageContainer: {
    width: sn("33.33%", "25%", "20%", "16.5%"),
    padding: 5,
    aspectRatio: 0.75,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    borderRadius: sizes.radius.xl,
  },

  image: {
    width: "100%",
    height: "100%",
    elevation: 1,
    borderRadius: sizes.radius.xl,
    backgroundColor: colors.itemsBg,
  },

  center: { alignItems: "center", justifyContent: "center" },

  pickButton: {
    width: sn(100, 100, 150, 150),
    height: sn(100, 100, 150, 150),
    alignItems: "center",
    justifyContent: "center",
    borderRadius: sizes.radius.xxxl,
  },
});
